import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/nfl-ended.module.scss';

const propTypes = {
    className: PropTypes.string,
    points: PropTypes.number,
};

const defaultProps = {
    className: null,
    points: null,
};

function NflEnded({ className, points }) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <h1 className={styles.title}>
                {points > 0 ? (
                    <FormattedMessage
                        defaultMessage="Congrats!{br}You scored:"
                        description="Nfl game Ended title"
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="Better luck next time!"
                        description="Sport game ended title no points"
                    />
                )}
            </h1>
            <div className={styles.pill}>
                <FormattedMessage
                    defaultMessage="{count, plural, =0 {# pt} one {# pt} other {# pts!}}"
                    description="Nhl game Ended points"
                    values={{ count: points || 0 }}
                />
            </div>
            {points === 0 ? (
                <div className={styles.description}>
                    <strong>
                        <FormattedMessage
                            defaultMessage="The real winner tonight is... YOU!"
                            description="Nfl game Ended description line 1"
                        />
                    </strong>
                    <br />
                    <FormattedMessage
                        defaultMessage="See you next game for more predictions."
                        description="Nfl game Ended description line 2"
                    />
                </div>
            ) : null}
        </div>
    );
}

NflEnded.propTypes = propTypes;
NflEnded.defaultProps = defaultProps;

export default NflEnded;
